export const TextBox = 1;
export const TextArea = 2;
export const DropDown = 3;
export const Radio = 4;
export const File = 5;
export const Display = 6;
export const Checkbox = 7;

export const Progress = 11;